var render, staticRenderFns
import script from "./PublicationsForm.vue?vue&type=script&lang=js&"
export * from "./PublicationsForm.vue?vue&type=script&lang=js&"
import style0 from "./PublicationsForm.vue?vue&type=style&index=0&id=6ee89063&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee89063",
  null
  
)

export default component.exports